import { ReviewType } from '../enums';
import { IActivityLocation, IBoondock, IListing, IReservation, IReview, IUser } from '../interfaces';

export class Review implements IReview {
  id?: number;
  syncId: string;
  reviewType: ReviewType;
  review: string;
  privateMessage?: string;
  reservation?: IReservation;
  reservationId?: number;
  listing?: IListing;
  listingId?: number;
  boondock?: IBoondock;
  boondockId?: number;
  poi?: IActivityLocation;
  poiId?: number;
  creator: IUser;
  creatorId: number;
  created: number;

  constructor(data?: IReview) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IReview): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }
  }
}
